declare global {
    interface Window {
        FB: any;
        createObjectURL(blob: Blob): any;
        revokeObjectURL(url: any);
        webkitURL?: any;
    }
}

export class SvgExporter {

    private copyStylesInline(destinationNode, sourceNode) {
        var containerElements = ["svg", "g"];
        for (var cd = 0; cd < destinationNode.childNodes.length; cd++) {
            var child = destinationNode.childNodes[cd];
            if (containerElements.indexOf(child.tagName) != -1) {
                this.copyStylesInline(child, sourceNode.childNodes[cd]);
                continue;
            }
            var style = sourceNode.childNodes[cd].currentStyle || window.getComputedStyle(sourceNode.childNodes[cd]);
            if (style == "undefined" || style == null) continue;
            for (var st = 0; st < style.length; st++) {
                child.style.setProperty(style[st], style.getPropertyValue(style[st]));
            }
        }
    }

    private triggerDownload(imgURI, fileName: string) {
        var evt = new MouseEvent("click", {
            view: window,
            bubbles: false,
            cancelable: true
        });
        var a = document.createElement("a");
        a.setAttribute("download", fileName);
        a.setAttribute("href", imgURI);
        a.setAttribute("target", '_blank');
        a.dispatchEvent(evt);
    }

    private generateSvgBlob(svg: any): Blob {

        var copy = svg.cloneNode(true);
        this.copyStylesInline(copy, svg);
        var data = (new XMLSerializer()).serializeToString(copy);
        var svgBlob = new Blob([data], { type: "image/svg+xml;charset=utf-8" });
        return svgBlob;

    }


    downloadSvgAsync(svg: any, width: number, height: number, fileName: string): Promise<HTMLCanvasElement> {
        return this.generateSvgAsync(svg, width, height)
        .then(
            canvas => {
                const imgURI = canvas
                    .toDataURL("image/png")
                    .replace("image/png", "image/octet-stream");
                this.triggerDownload(imgURI, fileName);
                //}
                return canvas;
            });
    }


    generateSvgAsync(svg: any, width: number, height: number
        /*, callBack: (canvas: HTMLCanvasElement, blob: Blob) => void*/
    ): Promise<HTMLCanvasElement> {

        // Firefox hack
        // https://bugzilla.mozilla.org/show_bug.cgi?id=700533#c39
        if (navigator.userAgent.search("Firefox") >= 0) {
            svg.setAttribute('width', `${width.toString()}px`);
            svg.setAttribute('height', `${height.toString()}px`);
        }

        var svgBlob = this.generateSvgBlob(svg);


        var canvas = document.createElement("canvas");
        //var bbox = svg.getBBox();
        canvas.width = width; // bbox.width;
        canvas.height = height; // bbox.height;
        var ctx = canvas.getContext("2d");
        ctx.clearRect(0, 0, width, height);

        var DOMURL = window.URL || window.webkitURL || window;

        var img = new Image();
        var url = DOMURL.createObjectURL(svgBlob);

        var promiseResolve;
        var promise = new Promise<HTMLCanvasElement>(resolve => {
            promiseResolve = resolve;
        });

        img.onload = () => {
            ctx.drawImage(img, 0, 0);
            DOMURL.revokeObjectURL(url);
            //if (typeof navigator !== "undefined" && navigator.msSaveOrOpenBlob) {
            //    var blob = canvas.msToBlob();
            //    navigator.msSaveOrOpenBlob(blob, fileName);
            //}
            //else {
            promiseResolve(canvas);
//            callBack(canvas, svgBlob);

            // alan resolve - document.removeChild(canvas);
        };
        img.src = url;

        return promise;
    }

}


// WEBPACK FOOTER //
// ./ClientApp/scripts/ah.mb.svg-exporter.ts